import React from "react";
import { Container, Box, Typography, Grid } from "@mui/material";
import Design1 from "../resources/images/Design1.png";
import Design2 from "../resources/images/Design2.png";
import Design3 from "../resources/images/Design3.png";
import Design4 from "../resources/images/Design4.png";
import { FONT_GABRIOLA } from "../common/constant";

const Story = () => {
  const designs = [
    { image: Design1, title: "Architecture" },
    { image: Design2, title: "Custom Furniture Design" },
    { image: Design3, title: "Interior Design" },
    { image: Design4, title: "Landscape Design" },
  ];

  return (
    <Container
      maxWidth="xl"
      sx={{ pl: "0 !important", pr: "0 !important", my: 8 }}
    >
      <Box
        // data-aos="fade-up"
        sx={{
          px: {
            lg: 12,
            md: 8,
            sm: 4,
            xs: 2,
          },
        }}
      >
        <Box textAlign="center" my={2}>
          <Typography
            variant="h1"
            fontWeight="400"
            fontFamily={FONT_GABRIOLA}
            sx={{
              fontSize: { xs: 26, sm: 34, md: 44, lg: 50 },
              lineHeight: { xs: "24px", sm: "38px", md: "48px", lg: "54px" },
              maxWidth: { xs: "auto", md: "1054px", lg: "1180px" },
              mx: "auto",
            }}
            color={"#444444"}
          >
            Luxury Architectural Interior Company, We don’t just design spaces;
            we weave narratives
          </Typography>
          <Typography
            variant="h4"
            mt={3}
            mb={"52px"}
            fontWeight={400}
            color={"#656565"}
            sx={{
              fontSize: { xs: 15, sm: 17, md: 19, lg: 20 },
              maxWidth: 1330,
              mx: "auto",
            }}
          >
            We partner with you to craft your unique narrative through our
            end-to-end design services. Your aspirations become the plot, your
            style the setting, and your life the story.
          </Typography>
        </Box>

        <Grid container spacing={2}>
          {designs.map((design, index) => (
            <Grid
              key={index}
              item
              xs={6}
              md={3}
              justifyContent="center"
              alignItems="center"
            >
              <Box
                sx={{
                  p: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    p: {
                      md: 2,
                      xs: 0,
                    },
                  }}
                >
                  <img
                    src={design.image}
                    alt={`Design ${index + 1}`}
                    width="100%"
                    height="100%"
                    // style={{ background: "#E6E6E6" }}
                    loading="lazy"
                  />
                </Box>
                <Typography
                  variant="h3"
                  mt={1}
                  textAlign="center"
                  fontFamily={FONT_GABRIOLA}
                  fontWeight={400}
                  color={"#444444"}
                >
                  {design.title}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default Story;
